import { render } from "./DeliverySheet.vue?vue&type=template&id=7648954d&scoped=true"
import script from "./DeliverySheet.vue?vue&type=script&lang=js"
export * from "./DeliverySheet.vue?vue&type=script&lang=js"

import "./DeliverySheet.vue?vue&type=style&index=0&id=7648954d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7648954d"]])

export default __exports__